const start = () => {
  const sel = (id) => document.getElementById(id);
  const visual = sel('visual');
  if (!visual) return;

  const lines = [
    sel('js-anime-line1'),
    sel('js-anime-line2'),
    sel('js-anime-line3'),
    sel('js-anime-line4'),
    sel('js-anime-line5'),
  ].filter(Boolean);

  const faces = [
    sel('js-anime-yokokao1'),
    sel('js-anime-yokokao2'),
    sel('js-anime-yokokao3'),
    sel('js-anime-yokokao4'),
    sel('js-anime-yokokao5'),
    sel('js-anime-yokokao6'),
    sel('js-anime-yokokao7'),
    sel('js-anime-yokokao8'),
    sel('js-anime-yokokao9'),
  ].filter(Boolean);

  // lazy img
  document.querySelectorAll('#visual img.c-image__src[data-lazy-img]').forEach((img) => {
    const url = img.getAttribute('data-lazy-img');
    if (url) img.setAttribute('src', url);
  });

  // 初期状態（ここはデバイスで変えないなら mm外でOK）
  gsap.set(visual, { opacity: 1 });
  gsap.set(lines, {
    scaleY: 0,
    transformOrigin: '50% 0%',
    opacity: 0.0001,
    skewY: 6,
  });
  gsap.set(faces, {
    opacity: 0,
    y: 30,
    clipPath: 'inset(0 0 100% 0 round 0px)',
    scale: 1.08,
  });
  gsap.set('#js-anime-title2', { opacity: 0, scale: 1.08 });

  const root = document.getElementById('js-anime-diamond');
  if (!root) return;

  // lazy bg
  root.querySelectorAll('.background[data-lazy-background]').forEach((el) => {
    const url = el.getAttribute('data-lazy-background');
    if (url) el.style.backgroundImage = `url('${url}')`;
  });

  const bgs = [
    root.querySelector('.background1'),
    root.querySelector('.background2'),
    root.querySelector('.background3'),
  ].filter(Boolean);
  if (!bgs.length) return;

  const yokos = [
    root.querySelector('.yokokao1'),
    root.querySelector('.yokokao2'),
    root.querySelector('.yokokao3'),
  ].filter(Boolean);
  if (!yokos.length) return;

  // 最終(left)はCSS値（着地）
  const finalBgsLefts = bgs.map((el) => getComputedStyle(el).left);
  const finalYokosLefts = yokos.map((el) => getComputedStyle(el).left);

  // ---- mask-position helpers ----
  const setMaskPxX = (el, px) => {
    const v = `${px}px 50%`;
    el.style.maskPosition = v;
    el.style.webkitMaskPosition = v;
  };

  // ===== メディア（1回だけ）=====
  const mm = gsap.matchMedia();

  mm.add(
    {
      isMobile: '(max-width: 767px)',
      isPC: '(min-width: 768px)',
    },
    (context) => {
      const { isMobile } = context.conditions;

      // ===============================
      // 1) SP/PCで変えたい値をここで全部決める
      // ===============================

      // 初期left（オフスクリーン）
      const initPlan = isMobile
        ? [
            { left: '-300%', maskFrom: -100 },
            { left: '300%', maskFrom: 200 },
            { left: '-320%', maskFrom: -100 },
          ]
        : [
            { left: '-100%', maskFrom: -100 },
            { left: '120%', maskFrom: 200 },
            { left: '-120%', maskFrom: -100 },
          ];

      // 背景ゆっくり
      const backgroundTargets = isMobile
        ? ['-160%', '-90%', '20%'] // 例
        : ['-25%', '-5%', '45%'];

      // 背景スライドアウト
      const backgroundTargets2 = isMobile
        ? ['-300%', '300%', '-300%'] // 例
        : ['-100%', '100%', '-100%'];

      // 横顔ゆっくり
      const yokokaoTargets = isMobile
        ? ['13%', '-3%', '-12%'] // 例
        : ['-32%', '3%', '38%'];

      // 横顔スライドアウト
      const yokokaoTargets2 = isMobile
        ? ['-300%', '300%', '-300%'] // 例
        : ['-100%', '100%', '-100%'];

      // maskの終点
      const pEnd2 = isMobile ? -120 : -550;
      const pEnd3 = isMobile ? -320 : -120;

      // ===============================
      // 2) 初期配置（left/mask）も mm内でやる
      // ===============================
      bgs.forEach((el, i) => {
        const plan = initPlan[i] || initPlan[0];
        el.style.opacity = 1;
        el.style.position = 'absolute';
        el.style.zIndex = 10;
        el.style.left = plan.left;
      });

      yokos.forEach((el, i) => {
        const plan = initPlan[i] || initPlan[0];
        const from = i % 2 === 0 ? -1000 : 1850;
        setMaskPxX(el, from);
        el.style.opacity = 1;
        el.style.zIndex = 20;
        el.style.left = plan.left;
      });

      // ===============================
      // 3) tlは mm内で作る（ここ超重要）
      // ===============================
      const tl = gsap.timeline({ defaults: { ease: 'power4.inOut' } });

      // 背景スライドイン
      bgs.forEach((el, i) => {
        tl.to(el, { left: finalBgsLefts[i], duration: 0.8, ease: 'power3.inOut' }, 0.25 + i * 0.1);
      });

      // 背景ゆっくり
      bgs.forEach((el, i) => {
        tl.to(
          el,
          { left: backgroundTargets[i], duration: 2.0, ease: 'linear' },
          0.25 + i * 0.1 + 0.8,
        );
      });

      // 背景スライドアウト
      bgs.forEach((el, i) => {
        tl.to(
          el,
          { left: backgroundTargets2[i], duration: 0.4, ease: 'power4.in' },
          0.25 + i * 0.1 + 2.8,
        );
      });

      // 横顔スライド
      yokos.forEach((el, i) => {
        const fromA = isMobile ? -970 : -100; // 偶数番の from
        const fromB = isMobile ? 940 : 185; // 奇数番の from
        const from = i % 2 === 0 ? fromA : fromB;
        const mid = i % 2 === 0 ? fromB : fromA; // 反対側まで走らせる

        const proxy = { p: from };

        // スライドイン
        tl.to(
          el,
          { left: finalYokosLefts[i], duration: 1.8, ease: 'power3.inOut' },
          0.25 + i * 0.1,
        );

        // 横顔ゆっくり left
        tl.to(el, { left: yokokaoTargets[i], duration: 1.5, ease: 'linear' }, '>-0.15');

        // mask
        tl.to(
          proxy,
          {
            p: mid,
            duration: 1.8,
            ease: 'expo.inOut',
            onUpdate() {
              setMaskPxX(el, proxy.p);
            },
          },
          0.2 + i * 0.2,
        );

        tl.to(
          proxy,
          {
            p: pEnd2,
            duration: 1.1,
            ease: 'power3.out',
            onUpdate() {
              setMaskPxX(el, proxy.p);
            },
          },
          '>-0.5',
        );

        tl.to(
          proxy,
          {
            p: pEnd3,
            duration: 1.1,
            ease: 'power3.out',
            onUpdate() {
              setMaskPxX(el, proxy.p);
            },
          },
          '>-0.5',
        );

        // スライドアウト
        tl.to(el, { left: yokokaoTargets2[i], duration: 0.4, ease: 'power4.in' }, '>-0.15');
      });

      // 滲みリセット（保険）
      tl.set(bgs, { filter: 'none' }, '>-0.1');
      tl.set(yokos, { filter: 'none' }, '>-0.1');

      // lines / faces / title（ここはそのまま移植でOK）
      tl.to(
        lines,
        {
          scaleY: 1,
          opacity: 1,
          duration: 0.9,
          skewY: 0,
          stagger: { each: 0.08, from: 'edges' },
        },
        '>-0.5',
      );

      tl.to(
        faces,
        {
          opacity: 1,
          y: 0,
          scale: 1,
          clipPath: 'inset(0 0 0% 0 round 0px)',
          duration: 0.9,
          ease: 'power3.out',
          stagger: { each: 0.12, from: 'random' },
        },
        '>-0.5',
      );

      tl.to('#js-anime-title1', { opacity: 0, y: 0, scale: 1, duration: 0.6 }, '>-0.5');

      tl.to('#js-anime-title2', { opacity: 1, y: 0, scale: 1 }, '>-0.5');

      // ===============================
      // 4) ScrollTrigger（SP/PC値）も同じmm内で
      // ===============================
      gsap.to(visual, {
        opacity: 0.3,
        y: isMobile ? 500 : 1000,
        ease: 'none',
        scrollTrigger: {
          trigger: visual,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      });

      gsap.to(['#js-anime-title1', '#js-anime-title2'], {
        y: isMobile ? -500 : -1000,
        ease: 'none',
        scrollTrigger: {
          trigger: visual,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      });

      // optional: 返すとmm切替時に確実に掃除される
      return () => {
        tl.kill();
        ScrollTrigger.getAll().forEach((st) => st.kill());
      };
    },
  );
};

export default { start };
